var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5053 25.2211C26.5053 22.288 28.9684 19.9158 32 19.9158C35.0316 19.9158 37.4947 22.288 37.4947 25.2211C37.4947 28.1541 35.0316 30.5263 32 30.5263C28.9684 30.5263 26.5053 28.1541 26.5053 25.2211ZM28.3394 25.2059C28.3394 27.1613 29.9764 28.7453 32 28.7453C34.0236 28.7453 35.6606 27.1613 35.6606 25.2059C35.6606 23.2505 34.0236 21.6665 32 21.6665C29.9764 21.6665 28.3394 23.2505 28.3394 25.2059Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.8 30.8901V27.6994C42.8 12.7764 32 4 32 4C32 4 21.2 12.7764 21.2 27.6918V30.8825C16.7512 33.3457 14 37.984 14 43.1225V52.7705L21.2 49.1554V54.4C21.2 54.4 26.2021 52.2931 32 52.2931C38.2072 52.2931 42.8 54.4 42.8 54.4V49.1554L50 52.7705V43.1225C49.9924 37.984 47.2488 33.3533 42.8 30.8901ZM48.2038 49.8451L42.8076 47.1394V32.9971C46.1726 35.2404 48.2038 38.9996 48.2038 43.1377V49.8451ZM41.0038 51.8611C38.3891 51.0274 35.3423 50.4665 32 50.4665C28.9381 50.4665 25.9141 50.9288 23.0038 51.8611V27.6918C23.0038 23.9857 23.7086 20.3629 25.0349 16.9676H38.9726C40.2838 20.3478 41.0038 23.9857 41.0038 27.6918V51.8611ZM32 6.46316C34.592 8.97937 36.6838 11.9427 38.192 15.1714H25.808C27.3238 11.9352 29.408 8.97179 32 6.46316ZM21.2 47.1394L15.8038 49.8451V43.1225C15.8038 38.9844 17.8349 35.2253 21.2 32.9819V47.1394Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0526 53.2632V58.5684H32.9474V53.2632H31.0526Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8421 55.1579H36.3579V60.4632H34.8421V55.1579Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1579 55.1579H27.2632V60.4632H29.1579V55.1579Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRocket);
export default __webpack_public_path__ + "static/media/icon-rocket.dc156edf5c18f98881b5af7699fb4618.svg";
export { ForwardRef as ReactComponent };